import { forwardRef } from 'react'

import { stringUtils } from '@/utils/String'

import Input from './Input'

type Props = React.ComponentPropsWithoutRef<typeof Input>

const NumericInput = forwardRef<HTMLInputElement, Props>(({ onChange, ...props }, ref) => {
  return (
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      {...props}
      onChange={(e) => {
        const currentValue = e.target.value
        const value = stringUtils.toNumber(currentValue)
        e.target.value = value.toString()
        onChange?.(e)
      }}
    />
  )
})

NumericInput.displayName = 'NumericInput'

export default NumericInput
